import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { MdLock } from 'react-icons/md';

import {
  Container,
  ModalContainer,
  ModalHeader,
  ModalFooter,
  ButtonModal,
} from './styles';

const ModalReaberturaCompetencia = ({
  modalIsVisible,
  setModalIsVisible,
  setModalConfirma,
  reabrirCompetenciaDados,
  rejeitaPedidoReabertura,
}) => {
  const [confirmLoading, setConfirmLoading] = useState(false);

  const { mesCompetencia, nomeSolicitante } = reabrirCompetenciaDados;

  const splitPeriodo = String(mesCompetencia).split('/');

  const mesPeriodoN = splitPeriodo[0];
  const anoPeriodo = splitPeriodo[1];

  const mesPeriodo =
    (mesPeriodoN === '01' && 'Janeiro') ||
    (mesPeriodoN === '02' && 'Fevereiro') ||
    (mesPeriodoN === '03' && 'Março') ||
    (mesPeriodoN === '04' && 'Abril') ||
    (mesPeriodoN === '05' && 'Maio') ||
    (mesPeriodoN === '06' && 'Junho') ||
    (mesPeriodoN === '07' && 'Julho') ||
    (mesPeriodoN === '08' && 'Agosto') ||
    (mesPeriodoN === '09' && 'Setembro') ||
    (mesPeriodoN === '10' && 'Outubro') ||
    (mesPeriodoN === '11' && 'Novembro') ||
    (mesPeriodoN === '12' && 'Dezembro');

  const handleOk = () => {
    setModalIsVisible(false);
    setModalConfirma(true);
  };
  const handleCancel = () => {
    setModalIsVisible(false);
  };

  const rejeitaPedido = () => {
    rejeitaPedidoReabertura();
  };

  return (
    <Container>
      <Modal
        visible={modalIsVisible}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        cancelText="Conferir depois"
        centered
        footer={null}
        width="480px"
      >
        <ModalContainer>
          <ModalHeader>
            <div className="iconModal">
              <span>
                <MdLock size={30} />
              </span>
            </div>
            <h2>
              Requisição de <span>reabertura de competência</span>
            </h2>
          </ModalHeader>
          <div className="ModalBody">
            <div>
              <span>Solicitante:</span>
              <p>{nomeSolicitante}</p>
            </div>

            <div>
              <span>Competência:</span>
              <p>
                {mesPeriodo} / {anoPeriodo}
              </p>
            </div>
          </div>
        </ModalContainer>

        <ModalFooter>
          <ButtonModal type="button" onClick={handleOk}>
            {confirmLoading ? ' Enviando...' : 'Permitir reabertura'}
          </ButtonModal>
          <ButtonModal type="button" cancel onClick={rejeitaPedido}>
            Não permitir
          </ButtonModal>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

ModalReaberturaCompetencia.propTypes = {
  modalIsVisible: PropTypes.bool.isRequired,
  setModalIsVisible: PropTypes.func,
  setModalConfirma: PropTypes.func,
  rejeitaPedidoReabertura: PropTypes.func.isRequired,
};

ModalReaberturaCompetencia.defaultProps = {
  setModalIsVisible: null,
  setModalConfirma: null,
};

export default ModalReaberturaCompetencia;
